import React, { useState, useEffect } from 'react'
import { Button, Modal, Skeleton } from 'antd'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Surface, Symbols } from 'recharts'

import './index.less'
import _ from 'lodash'
import moment from 'moment'
import { getChartDataCheckCount } from '../../../api/different'

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#FF33FF', '#6600FF', '#33CCCC', '#66CC33', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#0088FE', '#00C49F', '#FFBB28', '#FF8042']

const ChartCheckCount = () => {
  const [activeLine, setActiveLine] = useState(null)
  const [maxValue, setMaxValue] = useState(null)
  const [data, setData] = useState([])
  const [loadingChart, setLoadingChart] = useState(true)

  useEffect(() => {
    setLoadingChart(true)
    const params = {
      date_begin: moment().add(-1, 'M').format('DD.MM.YYYY'),
      date_end: moment().format('DD.MM.YYYY'),
    }

    getChartDataCheckCount(params)
      .then((res) => {
        const legend = []
        Object.values(_.groupBy(res.result, 'f_sellers')).map((item) => {
          legend.push({ seller: item[0].s_sellers, idnum: item[0].f_sellers })
        })

        const charData = []

        Object.values(_.groupBy(res.result, 'date')).map((item, key) => {
          charData[key] = { date: item[0].date }

          legend.map((itemLegend, keyLegend) => {
            charData[key] = { ...charData[key], [itemLegend.idnum]: _.find(item, { f_sellers: itemLegend.idnum }) ? Number(_.find(item, { f_sellers: itemLegend.idnum }).cnt) : 0 }
          })
        })

        const newDataChart = {
          legend,
          chartData: charData,
        }

        setData(newDataChart)
        setLoadingChart(false)
      })
      .catch((res) => {
        console.log(res)
        console.log('Error')
        setLoadingChart(false)
      })
  }, [])

  const CustomTooltip = ({ active, payload, label }) => {
    if (active) {
      return (
        <div style={{
 maxHeight: 400, overflow: 'auto', backgroundColor: 'rgb(255 255 255 / 0.80)', padding: 10, borderRadius: 4, border: '1px solid rgb(204, 204, 204)',
}}
        >
          <p style={{ fontWeight: 700 }}>{moment(label).format('DD.MM.YYYY')}</p>
          {_.orderBy(payload, ['value'], ['desc']).map((item, key) => (activeLine
            ? activeLine === item.dataKey && <p style={{ color: item.stroke }} key={item.dataKey}>{item.name} : {item.value}</p>
            : <p style={{ color: item.stroke, fontSize: 10, marginBottom: 0 }} key={item.dataKey} >{item.name} : {item.value}</p>))}
        </div>
      )
    }

    return null
  }

  useEffect(() => {
    const b = _.maxBy(data.chartData, activeLine)
    const newVal = !b ? 0 : b[activeLine]
    setMaxValue(newVal)
  }, [activeLine, loadingChart])

  const formatXAxis = tickItem => moment(tickItem).format('DD.MM.YYYY')

  const handleMouseEnter = (o) => {
    const { dataKey } = o
    const newActive = activeLine === dataKey ? null : dataKey
    setActiveLine(newActive)
  }

  const renderCusomizedLegend = (props) => {
    const { payload } = props
    return (
      <div className='customized-legend' style={{ textAlign: 'center' }}>
        {
          payload.map((entry) => {
            const { dataKey, color, value } = entry
            let style = {}
            if (dataKey === activeLine) {
              style = { fontWeight: 700 }
            }

            return (
              <span key={dataKey} className='legend-item' onClick={() => handleMouseEnter(entry)} style={{ ...style, marginRight: 10, whiteSpace: 'nowrap' }}>
                <Surface width={20} height={10}>
                  <Symbols cx={10} cy={5} type='circle' size={50} fill={color} />
                </Surface>
                <span>{value}</span>
              </span>
            )
          })
        }
      </div>
    )
  }

  return (
    <div style={{ width: '95%', height: 400 }}>
      {!loadingChart ?
        <ResponsiveContainer>
          <LineChart
            width={500}
            height={300}
            data={data.chartData}
            margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
          >
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis scale='auto' dataKey='date' tickFormatter={formatXAxis} />
            <YAxis allowDataOverflow domain={[0, maxValue]} />
            <Tooltip wrapperStyle={{ pointerEvents: 'auto' }} content={<CustomTooltip />} />
            <Legend onClick={handleMouseEnter} content={renderCusomizedLegend} />
            {data.legend.map((item, key) => <Line opacity={(item.idnum === activeLine || !activeLine) ? 1 : 0.1} key={item.idnum} type='monotone' dataKey={item.idnum} name={item.seller} strokeOpacity={1} stroke={COLORS[key]} />)}
          </LineChart>
        </ResponsiveContainer>
      :
        <Skeleton active />}
    </div>
  )
}

export default ChartCheckCount



// WEBPACK FOOTER //
// src/containers/Dashboard/ChartCheckCount/index.jsx